import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { useStationeryTemplateProductPrices } from '../../hooks/useStationeryTemplateProductPrices';
import type { StationeryTemplate } from '../../../../DesignsGallery.types';
import { CardTileDiscountedPriceLabel } from '../../../CardTileDiscountedPriceLabel';
import { useStationeryTemplateCategoryTranslations } from '@apps/card/hooks/useStationeryTemplateCategoryTranslations';
import { useActivePrintFiltersVar } from '../../../../utils/activePrintFiltersCache';
import { useSearchContext } from '../../../Search/SearchContext';

type ProductPricesProps = {
  template: Pick<StationeryTemplate, 'products' | 'category' | 'mappedTags'>;
  explicitPaperDigitalCategory?: boolean;
};

export const ProductPrices = (props: ProductPricesProps) => {
  const { template, explicitPaperDigitalCategory = false } = props;
  const productPrices = useStationeryTemplateProductPrices(template);
  const getPaperCategoryName = useStationeryTemplateCategoryTranslations('stationeryTemplateCategoryToTile');
  const getDigitalCategoryName = useStationeryTemplateCategoryTranslations('stationeryTemplateCategoryToDigitalTile');

  const activePrintFilters = useActivePrintFiltersVar();
  const filterOnlyFree = activePrintFilters.has('price:basic') && !activePrintFilters.has('price:premium');

  const { wantsFree: searchWantsFree } = useSearchContext();

  return (
    <Flex
      flexDirection="column"
      gap="4px"
      justifyContent="center"
    >
      {productPrices.map(product => {
        const isDiscountDifferent = product.preDiscountedPrice !== product.basePrice;
        const showDiscountedPrice = !!product.preDiscountedPrice && !!product.discount && isDiscountDifferent;

        const name = (() => {
          if (explicitPaperDigitalCategory) {
            if (product.name === 'Paper') return getPaperCategoryName(template.category);
            if (product.name === 'Digital') return getDigitalCategoryName(template.category);
          }

          return product.name;
        })();

        if (product.name === 'Digital' && template.mappedTags.includes('price:basic') && (searchWantsFree || filterOnlyFree)) {
          return (
            <CardTileDiscountedPriceLabel
              key={product.productId}
              prefixLabel={name}
              discountedPrice="Free"
              sale={product.discount!.fullPromoConfig}
            />
          );
        }

        if (showDiscountedPrice)
          return (
            <CardTileDiscountedPriceLabel
              key={product.productId}
              prefixLabel={name}
              preDiscountPrice={product.preDiscountedPrice!}
              discountedPrice={product.basePrice}
              sale={product.discount!.fullPromoConfig}
            />
          );

        return (
          <TextV2
            key={product.productId}
            typographyVariant="label2"
            margin="auto 0 auto 0"
          >
            {name} {product.basePrice}
          </TextV2>
        );
      })}
    </Flex>
  );
};
